import React, { Component } from 'react'
import { array, any, func } from 'prop-types'
import FaClose from 'react-icons/lib/fa/close'
import styles from './CircuitPopup.styl'

export default class CircuitPopup extends Component {
	static propTypes = {
		exercises: array,
		percentage: any,
		close: func
	}
	constructor(props) {
		super(props)
		const open = props.exercises.map(() => false)
		this.state = { open }
	}
	componentDidMount() {
		document.body.style.overflow = 'hidden'
	}
	componentWillUnmount() {
		document.body.style.overflow = 'inherit'
	}
	openTabs(i) {
		const { open } = this.state
		const newState = new Array(open.length).fill(false)
		newState[i] = !open[i]
		this.setState({ open: newState })
	}
	render() {
		const { open } = this.state
		const { exercises, percentage, close } = this.props
		const content = exercises.map((ele, i) => (
			<li key={ i }>
				<div className={ styles.line } onClick={ () => { this.openTabs(i) } }>
					<span className={ styles.exercise }>{ ele.name }</span>
					<span className={ styles.rep }>{ ele.repetitions } x { Math.round(ele.duration * (percentage || 100) / 100) }</span>
				</div>
				<div className={ `${ styles.image } ${ open[i] ? styles['transition'] : '' }` } style={ { backgroundImage: open[i] ? `url(${ ele.image })` : null } } />
			</li>
		))
		return (
			<div className={ styles['circuit'] }>
				<div className={ styles['container'] }>
					<div className={ styles['title-container'] }>
						<FaClose
							onClick={ close }
							color="#fff"
						/>
						<h2>Circuito de Treino</h2>
					</div>
					<ul className={ styles['list'] }>
						<li>
							<div className={ styles.line }>
								<span className={ `${ styles.exercise } ${ styles.title }` }>Exercício</span>
								<span className={ `${ styles.rep } ${ styles.title }` }>Repetições</span>
							</div>
						</li>
						{ content }
					</ul>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/CircuitPopup/CircuitPopup.js